/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Drawer } from "__barrel_optimize__?names=Box,Drawer!=!@mui/material";
import Link from 'next/link';
import logo from '@/app/img/logo-500x500.png';
const inspectionLinks = [
    {
        name: 'Standard',
        href: '/inspections/standard'
    },
    {
        name: 'Exotic',
        href: '/inspections/exotic'
    },
    {
        name: 'Classic',
        href: '/inspections/classic'
    },
    {
        name: 'Electric',
        href: '/inspections/electric'
    },
    {
        name: 'Motorcycle',
        href: '/inspections/motorcycle'
    }
];
const useCaseLinks = [
    {
        name: 'Car Buyers',
        href: '/use-cases/car-buyers'
    },
    {
        name: 'Car Sellers',
        href: '/use-cases/car-sellers'
    },
    {
        name: 'Dealerships',
        href: '/use-cases/dealerships'
    },
    {
        name: 'Fleet Managers',
        href: '/use-cases/fleet-managers'
    }
];
const resourceLinks = [
    {
        name: 'How It Works',
        href: '/how-it-works'
    },
    {
        name: 'Dealer Referral Program',
        href: '/dealer-referral-program'
    },
    {
        name: 'Blog',
        href: '/blog'
    },
    {
        name: 'Help Center',
        href: '/help-center'
    },
    {
        name: 'Contact Us',
        href: '/contact-us'
    }
];
const companyLinks = [
    {
        name: 'About Us',
        href: '/about'
    },
    {
        name: 'Careers',
        href: '/careers'
    }
];
function CollapsibleSection(param) {
    let { title, links, onNavigate } = param;
    const [expanded, setExpanded] = React.useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "border-b border-neutral-100",
        children: [
            /*#__PURE__*/ _jsxs("button", {
                onClick: ()=>setExpanded(!expanded),
                className: "flex items-center justify-between w-full py-3.5 text-sm font-semibold text-[var(--dark-blue)]",
                children: [
                    title,
                    /*#__PURE__*/ _jsx("i", {
                        className: "bi bi-chevron-down text-xs text-neutral-400 transition-transform duration-200 ".concat(expanded ? 'rotate-180' : '')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden transition-all duration-200 ".concat(expanded ? 'max-h-96 pb-3' : 'max-h-0'),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-0.5 pl-3",
                    children: links.map((link)=>/*#__PURE__*/ _jsx(Link, {
                            href: link.href,
                            onClick: onNavigate,
                            className: "text-sm text-neutral-600 py-2 px-3 rounded-lg hover:bg-neutral-50 transition-colors",
                            children: link.name
                        }, link.href))
                })
            })
        ]
    });
}
function MobileSidebar(param) {
    let { isAuthenticated } = param;
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(()=>{
        setMounted(true);
    }, []);
    const [open, setOpen] = React.useState(false);
    const handleClose = ()=>setOpen(false);
    if (!mounted) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "block md:hidden ml-5",
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: ()=>setOpen(!open),
                "aria-label": "Open navigation menu",
                children: /*#__PURE__*/ _jsx("i", {
                    className: "bi bi-list text-xl"
                })
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                anchor: "left",
                open: open,
                onClose: handleClose,
                children: /*#__PURE__*/ _jsxs(Box, {
                    role: "presentation",
                    className: "w-[80vw] max-w-sm bg-white min-h-screen flex flex-col",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between px-5 pt-5 pb-4 border-b border-neutral-100",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/",
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: logo.src,
                                        alt: "AutoVINsights",
                                        className: "h-7 aspect-auto"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: handleClose,
                                    "aria-label": "Close navigation menu",
                                    children: /*#__PURE__*/ _jsx("i", {
                                        className: "bi bi-x-lg text-neutral-500"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("nav", {
                            className: "flex-1 overflow-y-auto px-5 pt-3",
                            children: [
                                /*#__PURE__*/ _jsx(CollapsibleSection, {
                                    title: "Inspections",
                                    links: inspectionLinks,
                                    onNavigate: handleClose
                                }),
                                /*#__PURE__*/ _jsx(CollapsibleSection, {
                                    title: "Use Cases",
                                    links: useCaseLinks,
                                    onNavigate: handleClose
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/order",
                                    onClick: handleClose,
                                    className: "flex items-center py-3.5 text-sm font-semibold text-[var(--dark-blue)] border-b border-neutral-100",
                                    children: "Order an Inspection"
                                }),
                                /*#__PURE__*/ _jsx(CollapsibleSection, {
                                    title: "Resources",
                                    links: resourceLinks,
                                    onNavigate: handleClose
                                }),
                                /*#__PURE__*/ _jsx(CollapsibleSection, {
                                    title: "Company",
                                    links: companyLinks,
                                    onNavigate: handleClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "px-5 py-5 border-t border-neutral-100",
                            children: !isAuthenticated ? /*#__PURE__*/ _jsx(Link, {
                                href: "/login",
                                onClick: handleClose,
                                className: "block w-full text-center font-medium rounded-full py-3 bg-[var(--dark-blue)] text-white text-sm",
                                children: "Sign In"
                            }) : /*#__PURE__*/ _jsx(Link, {
                                href: "/customer/inspections",
                                onClick: handleClose,
                                className: "block w-full text-center font-medium rounded-full py-3 bg-[var(--dark-blue)] text-white text-sm",
                                children: "My Inspections"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export default MobileSidebar;
